import { Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';

import { RegisterMovementRequest } from '../../domain/registerMovementRequest';
import { MovementService } from './movement.service';
import { environment } from '../../../../environments/environment';

import { Subject } from 'rxjs/Subject';
import { ToastrService } from 'ngx-toastr';
import { Damage } from '../../domain/damage';

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-movement',
  templateUrl: './movement.component.html',
  styleUrls: ['./movement.component.scss']
})
export class MovementComponent implements OnInit {

  private registerMovementRequest: RegisterMovementRequest;
  private entity = 'movements';
  private movement: any;
  private loading = false;
  private columns = [];
  private damageTypes = [];
  private visibleElements = {
    truckInfo: false,
    shipInfo: false,
    damagesList: false,
    associateMovement: false
  };
  private enabledElements = {
    productCode: false
  };

  private status = {
    canDelete: true,
    canSave: false
  };

  constructor(private router: Router, private route: ActivatedRoute, private baseservice: ApiService,
    private modalService: NgbModal, private fb: FormBuilder, private movementservice: MovementService,
    private location: Location, protected toastr: ToastrService) {

    this.registerMovementRequest = new RegisterMovementRequest();
  }

  ngOnInit() {

    const id = +this.route.snapshot.params['id'];

    this.columns = [
      {
        headerCheckboxable: true, checkboxable: true, width: 30, sortable: false, canAutoResize: false,
        draggable: false, resizeable: false
      },
      {
        prop: 'Id', width: 120, sortable: false, canAutoResize: false, draggable: false, resizeable: false
      }
    ];

    this.baseservice.setEntity(this.entity + '/GetMovement');

    if (!isNaN(id) && id !== null && id !== undefined) {
      this.loading = true;
      this.baseservice.getById(id)
        .subscribe(return_value => {
          this.movement = return_value;
          this.visibleElements.associateMovement = this.movement.AnnouncementItemProduct == null;
          this.getDamageTypes();

          switch (this.movement.TypeID) {
            case 1:
            case 4:
              this.visibleElements.truckInfo = true;
              break;
            case 2:
            case 3:
              this.visibleElements.shipInfo = true;
              break;
          }

          this.loading = false;
        },
        error => console.log('Error fetching: ' + error));
    } else {
      this.movement = {};
    }

  }

  protected setAnnouncementItem(event, notFoundModalContent) {
    this.baseservice.setEntity(this.entity + '/AssociateMovementWithAnnouncementItem');
    const request = {
      'MovementId': this.movement.Id,
      'MovementType': this.movement.TypeID,
      'ProductCode': this.movement.Product,
      'TruckingCompanyId': this.movement.TruckingCompanyID,
      'TruckRegistration': this.movement.TruckRegistration,
      'TruckTrailer': this.movement.TruckTrailer,
      'VesselAndProcessId': this.movement.VesselAndProcessID
    };

    this.baseservice.postRequest(request).subscribe(response => {
      if (response.Movement != null) {
        this.movement = response.Movement;
        this.visibleElements.associateMovement = false;
        this.getDamageTypes();
      } else {
        this.modalService.open(notFoundModalContent, { backdrop: 'static', keyboard: false });
      }
    },
      error => console.log('Error fetching: ' + error)
    );
  }

  private delete(event: Event) {
    this.baseservice.setEntity(this.entity + '/CancelMovement?id=' + this.movement.Id);
    this.baseservice.postRequest(this.movement.Id).subscribe(() => {
      this.toastr.success('Movimento cancelado com sucesso', '', { timeOut: 3000 });
      this.router.navigateByUrl('/backoffice/movements');
    },
      error => {
        if (error.status === 404) {
          this.toastr.info('Este movimento não pode ser anulado.', '', { timeOut: 6000 });
        } else {
          this.toastr.error('Erro ao anular movimento.', '', { timeOut: 3000 });
          console.log('Error cancelling movement: ' + error);
        }
      }
    );
  }

  private cancel(event: Event) {
    this.router.navigateByUrl('/backoffice/movements');
  }

  private getDamageTypes() {
    if (this.movement == null) {
      return;
    }

    let productTypeId = null;

    if (this.movement.AnnouncementItemProduct != null &&
      this.movement.AnnouncementItemProduct.ProductTypeID != null) {
      productTypeId = this.movement.AnnouncementItemProduct.ProductTypeID;
    }

    const url = 'Damages/GetDamagesListByProductType?productTypeId=' + productTypeId;
    this.baseservice.setEntity(url);
    this.baseservice.getAll().subscribe(data => {

      if (this.movement.Damages != null && this.movement.Damages.length > 0) {
        data.forEach(damageType => {
          damageType.checked = this.movement.Damages.find(d => d.Id === damageType.Id) != null;
        });
      }

      this.damageTypes = data;

      // this.visibleElements.damagesList = true;
    },
      error => console.log('Error getting damage types: ' + error));
  }

  private updateSelectedDamagesList(event: Event) {
    const checkbox = <HTMLInputElement>event.target;

    if (checkbox.checked) {
      if (this.movement.Damages.find(d => d.Id === parseInt(checkbox.name)) == null) {
        const damage = new Damage();
        damage.Id = parseInt(checkbox.name);
        damage.Designation = checkbox.parentElement.previousElementSibling.textContent;
        this.movement.Damages.push(damage);
      }
    } else {
      const damageIndex = this.movement.Damages.findIndex(d => d.Id === parseInt(checkbox.name));
      if (damageIndex > -1) {
        this.movement.Damages.splice(damageIndex, 1);
      }
    }
  }

  private onDamagesFormSubmit() {
    this.baseservice.setEntity('Movements/SaveMovementDamages');

    this.baseservice.postRequest(this.movement).subscribe(
      data => this.toastr.success('Gravação efectuada com sucesso', '', { timeOut: 3000 }),
      error => console.log('Error saving movement damages: ' + error));
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/movements/movement.component.ts